<template>
  <div class="chartbar2">
    <div :id="'bar2Serise' + idhash" style="width: 100%; height: 100%"></div>
    <div class="nodata" v-if="data[0].length == 0">暂无数据</div>
  </div>
</template>
 
 


<script>
import chart from "../../utils/chartDark";
import echarts from "echarts";
import $ from "jquery";
export default {
  mixins: [chart],
  data: function () {
    return {
      idhash: null,
      isInit: false,
      chart: null,

      colorLegend: [],
      colorLinear: [],
      data: [[], []],
      title: [],
      legendSelect: {},
      xAxis: [],
      clickDoTime: null, //单双击
    };
  },
  props: {
    dataBar: {},
    colorSet: {
      default: function () {
        return ["green", "red"];
      },
    },
    legendGrid: {
      default: function () {
        return [10, 20];
      },
    },
    grid: {
      default: function () {
        return [50, 60, 30, 50];
      },
    },
  },
  created() {
    this.idhash = this.uuid();
  },
  methods: {
    dataHandle: function () {
      this.data = this.dataBar.data;
      this.title = this.dataBar.title;
      this.xAxis = this.dataBar.xAxis;
    },
    getOptAndDraw: function () {
      var legend = [];
      var series = [];
      var period = this.dataBar.period;
      for (var i = 0; i < this.title.length; i++) {
        legend.push(this.title[i]);
        var orignalD = this.data[i];
        var _orignalType = this.dataBar.seriesType[i];
        var yAxisIndex = this.dataBar.yAxisIndex[i];
        var seriesType = _orignalType;
        var itemStyle = {};
        var lineStyle = {};
        var label = {
          show: false,

          color: "#8C8C8C",
          fontSize: 1,
          fontWeight: "bold",
        };
        if (seriesType == "bar" && this.colorLinear != null) {
          itemStyle = {
            borderWidth: 12,
            normal: {
              barBorderRadius: [1, 1, 1, 1],
              color: this.colorLegend[i],
            },
          };
        }
        if (seriesType == "line") {
          itemStyle = {
            borderWidth: 2,
            color: this.colorLegend[i],
          };
          lineStyle = {
            width: 3,
          };
        }
        if (i == 0) {
          label.formatter = "{@score}";
          label.position = "left";
        }
        if (i == 1) {
          label.formatter = "{@score}";
          label.position = "right";
        }

        series.push({
          name: this.title[i],
          type: seriesType,
          smooth: true,
          itemStyle: itemStyle,
          lineStyle: lineStyle,
          yAxisIndex: yAxisIndex,
          data: orignalD,
          label: label,
          barMaxWidth: 8,
          showSymbol: false,
          symbolSize: 1,
          // areaStyle: areaStyle
        });
      }
      if (this.dataBar.type == "oildetail") {
        let _markArea={data:[]}
        this.dataBar.markArea.map(item=>{
          _markArea.data.push(
            [{
              xAxis: item[0],
              itemStyle: {
                color: item[2]==0?"rgba(242, 242, 242, 0.6)":item[2]==1?"rgba(0, 0, 255, 0.3)":"rgba(0, 128, 0, 0.3)",
              },
              emphasis: {
                itemStyle: {
                  color: item[2]==0?"rgba(242, 242, 242, 0.6)":item[2]==1?"rgba(0, 0, 255, 0.3)":"rgba(0, 128, 0, 0.3)",
                },
              },
            },
            {
              xAxis: item[1],
            },]
          )
        })
        series[0].markArea=_markArea
      }
      var xAxis1 = $.extend(true, {}, this.xAxisTemplate, {
        type: "category",
        data: this.xAxis,
        axisLabel: {
          fontSize: 12,
          padding: [0, 0, 0, 0],
          textStyle: {
            fontSize: 12,
            color: "#8C8C8C",
          },
          formatter: function (value) {
            if (period == "0") {
              return value.substr(5).replace("-", "/");
            } else {
              return value;
            }
          },
        },
        axisLine: {
          lineStyle: {
            color: "#8C8C8C",
          },
        },
      });
      var yAxis1 = $.extend(true, {}, this.yAxisTemplate, {
        type: "value",
        name: this.dataBar.yAxisUnit[0],
        nameTextStyle: {
          color: "#8C8C8C",
          padding: [0, 15, 0, 0],
        },
        axisLabel: {
          fontSize: 12,
          textStyle: {
            fontSize: 12,
            color: "#8C8C8C",
          },
        },
        axisLine: {
          show: false,
        },
        splitLine: {
          show: false,
          lineStyle: {
            color: "#0A3066",
            type: "solid",
          },
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
      });
      var yAxis2 = $.extend(true, {}, this.yAxisTemplate, {
        type: "value",
        // min: 0,
        // max: yAxis2Max,
        name:
          this.dataBar.yAxisUnit[this.dataBar.yAxisUnit.length - 1] ==
          this.dataBar.yAxisUnit[0]
            ? ""
            : this.dataBar.yAxisUnit[this.dataBar.yAxisUnit.length - 1],
        nameTextStyle: {
          color: "#8C8C8C",
          padding: [0, 0, 0, 15],
        },
        axisLabel: {
          fontSize: 12,
          textStyle: {
            fontSize: 12,
            color: "#8C8C8C",
          },
        },
        axisLine: {
          show: false,
        },
        axisTick: {
          lineStyle: {
            width: 0,
          },
        },
      });

      var option = {
        color: this.colorLegend,
        legend: {
          icon: "rect",
          itemHeight: 10,
          itemWidth: 10,
          data: legend,
          textStyle: {
            fontSize: 12,
            color: "#8C8C8C",
            padding: [0, 0, 0, 0],
          },
          // left: 24,
          itemGap: 16,
          right: this.legendGrid[1],
          top: this.legendGrid[0],
        },
        grid: {
          top: this.grid[0],
          right: this.grid[1],
          bottom: this.grid[2],
          left: this.grid[3] ? this.grid[3] : null,
          containLabel: false,
        },
        xAxis: xAxis1,
        yAxis: this.dataBar.yAxisUnit.length == 1 ? [yAxis1] : [yAxis1, yAxis2],
        // interval: xStep,
        dataZoom: [
          {
            type: "slider",
            show: true,
            realtime: true,
            start: period == "3" ? 0 : 30,
            end: period == "3" ? 100 : 100,
            handleSize: "10%",
            height: 8,
            // handleSize: 0,
            showDetail: false,
            showDataShadow: false,
            bottom: 0,
            backgroundColor: "#e4e3e8",
            handleStyle: {
              borderWidth: 0,
            },
            // bottom: "5%",
          },
          {
            type: "inside",
            xAxisIndex: [0],
          },
          {
            type: "slider",
            yAxisIndex: [0],
            show: false,
            zoomLock: true,
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          textStyle: {
            align: "left",
          },
        },
        series: series,
      };
      // this.chart.clear();
      console.log(option);
      if (option && typeof option === "object") {
        this.setChart(this.chart, option);
      }
    },
    initChart: function () {
      if (this.isInit == false) {
        // console.log('canvas')
        var dom = document.getElementById("bar2Serise" + this.idhash);
        this.chart = echarts.init(dom);
        var ths = this;
        this.chart.on("click", function (params) {
          clearTimeout(ths.clickDoTime);
          ths.clickDoTime = setTimeout(function () {
            // console.log(params,'params')
            ths.$emit("chartClick", params);
          }, 100);
        });
        // this.chart.on("dblclick", function() {
        //   clearTimeout(ths.clickDoTime);
        // });
        this.isInit = true;
      }
    },
  },
  mounted() {
    // console.log(this.colorSet);
    var cResult = this.setChartColor(this.colorSet);
    // console.log(cResult)
    this.colorLinear = cResult.cLinear;
    this.colorLegend = cResult.cLegend;
  },
  watch: {
    dataBar: {
      handler() {
        var cResult = this.setChartColor(this.colorSet);
        this.colorLinear = cResult.cLinear;
        this.colorLegend = cResult.cLegend;
        if (this.isInit == false) {
          this.initChart();
        }
        this.chart.clear();
        this.dataHandle();
        this.getOptAndDraw();
        this.chart.resize();
        if (this.dataBar.data[0].length == 0) {
          this.chart.clear();
        }
      },
      deep: true,
    },
  },
  components: {},
};
</script>   
 <style lang="scss" scoped>
.chartbar2 {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .nodata {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba($color: #ffffff, $alpha: 0.7);
    z-index: 100;
    text-align: center;
    line-height: 300px;
  }
}
</style>
 
   